<template>
  <SidePanel
    :isVisible="true"
    @cancel="onCancel"
    @save="onSave"
    :header="header"
    :save="saveText"
    :cancel="cancelText"
    :rightCommand="true"
    :disable="disable"
    :loading="loading"
  >
    <div class="sidepanel-body">
      <select-type
        :disabled="disabledTypeSelection"
        @input="whenSelect"
        v-model="type"
        active="active"
      />

      <template v-if="isTypeSelected">
        <div class="sidepanel-group">
          <InputText
            id="title"
            :label="$t('options.lbTitle') + ' *'"
            :placeholder="$t('options.phTitle')"
            v-model="title"
          />
          <span class="text-danger" v-if="title.length == 0">
            {{ $t('warnings.projectTitleRequired') }}
          </span>
        </div>
        <div class="sidepanel-group">
          <InputText
            :label="$t('options.lbDescription')"
            :placeholder="$t('options.phDescription')"
            v-model="description"
            :textareaCustomClass="getCustomClass"
          />
          <span class="text-size-10 pt-0 toggle-description">
            {{ getDescriptionLength }}
          </span>
        </div>

        <div v-if="isNewPoll" class="sidepanel-group">
          <input-text-validated
            :label="$t('general.userName') + ' *'"
            rules="required"
            type="text"
            vid="name"
            id="name"
            :placeholder="$t('general.phMyself')"
            v-model="name"
            autocomplete="off"
          />
          <span class="text-danger" v-if="errors.name">
            {{ errors.name[0] }}
          </span>
        </div>

        <div v-if="!isAuthenticated">
          <div class="sidepanel-group">
            <input-text-validated
              :label="$t('polls.lbEmail')"
              rules="required"
              type="email"
              vid="email"
              id="email"
              :readonly="!isNewPoll"
              v-model="email"
              autocomplete="off"
            />
          </div>
          <span class="text-danger" v-if="errors.email">
            {{ errors.email[0] }}
          </span>
        </div>

        <EditPollChoices v-if="poll.type == 3" />
        <EditPollDates v-if="poll.type == 1" />

        <EditPollAppearance
          @change="selectBGImage"
          @openCustomBranding="openCustomBranding"
        />

        <div class="panel-section-header text-panel-section-header mt-2">
          {{ $t('options.sectionGeneral') }}
        </div>

        <EditPollDeadline />
        

        <EditPollOptions @openConfigureAnswer="openConfigureAnswer" />

        <EditPollReminders />
        <hr />
        <div class="build-version text-size-10 text-size-semi-bold">
          Build number: {{ buildVersion }}
        </div>
      </template>
      <div class="sidepanel-footer"></div>
    </div>
    <ModalConfirm
      v-show="showConfirm"
      :msg="$t('polls.confirmRemove')"
      :loading="false"
      @cancel="onRemoveCancel"
      @confirm="onRemoveOK"
    />

    <ModalDialog
      ref="dlgZeroChoiceValidation"
      :title="$t('polls.choiceValidationHeader')"
      :labelOk="$t('general.ok')"
      :showCancelIcon="false"
      :displayCancelButton="false"
      @ok="closeValidationModal()"
      :displayOkButton="true"
    >
      <!-- replace true with isPaymentComplete in displayOkButton -->
      <div class="text-small" v-html="$t('polls.choiceValidationDescription')"></div>
    </ModalDialog>
  </SidePanel>
</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';

//import ToggleOption from '@/components/Edit/ToggleOption.vue';
//import Icon from '../UI/Icon.vue';
import EditPollDates from '@/components/Edit/EditPollDates.vue';
import EditPollChoices from '@/components/Edit/EditPollChoices.vue';
import EditPollAppearance from '@/components/Edit/EditPollAppearance.vue';
import EditPollReminders from '@/components/Edit/EditPollReminders.vue';
import EditPollOptions from '@/components/Edit/EditPollOptions.vue';
import EditPollDeadline from '@/components/Edit/EditPollDeadline.vue';

import InputText from '@/components/UI/InputText.vue';
import SelectType from '@/components/Edit/SelectType.vue';
import { formValidationMixin } from '@/components/mixins/FormValidationMixin.js';
import { dateMixin } from '@/components/mixins/DateMixins.js';
import { renderMixin } from '../mixins/RenderMixins';
import { constants } from '@/shared/constant';

import { mapState, mapGetters, mapActions } from 'vuex';

import { version } from '@/../../package';
import { extend, localize } from 'vee-validate';
import { required, max } from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';

import moment from 'moment';
// import CustomBrandingTemplates from './CustomBrandingTemplates.vue';
const customTemplate = require('../../shared/customTemplate');

extend('required', required);
extend('max', max);
localize('en', en);

function copy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export default {
  name: 'EditPoll',

  props: ['backup'],
  mixins: [formValidationMixin, dateMixin, renderMixin],

  components: {
    SidePanel,
    EditPollDates,
    EditPollChoices,
    EditPollAppearance,
    EditPollReminders,
    EditPollOptions,
    EditPollDeadline,
    InputText,
    SelectType,
  },

  data() {
    return {
      dateChoices: [],
      textChoices: [],

      localDetails: null,
      ownerUser: null,
      showConfirm: false,
      buildVersion: version,
      disable: false,
      displayScroll: false,

      numberOfDaySelection: [],
      autoReminderDeadlineOption: '',

      dialogContent: {
        title: '',
        description: '',
        cancelLabel: '',
        okLabel: '',
      },
      diplayReminderDetails: false,
      diplayAppearanceDetails: false,
      backupChoices: null,
      loading: false
    };
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
      ownerId: (state) => state.poll.poll.user.id,
      user: (state) => state.Login.user,
    }),

    ...mapGetters({
      userName: 'userName',
      isAuthenticated: 'isAuthenticated',
      currentParticipantName: 'currentParticipantName',
      isAdmin: 'isAdmin',
      isPremium: 'isPremium',
      getSelectedTemplate: 'getSelectedTemplate',
      designs: 'designs',
    }),

    isTypeSelected() {
      if( this.type > 0 ) return true;
      return false;
    },

    disabledTypeSelection() {
      if (this.isNewPoll) return false;
      return true;
    },

    backgroundImageThumnail() {
      return '/images/background_default_thumnail.jpg';
    },

    /* get formated dealine for reminder -> radio btton -> before dealine  */
    deadlineForReminder() {
      try {
        if (!this.pollDeadline) return this.$t('automateReminder.notSet'); // date not found than reurn default message (not set)
        return moment(String(this.pollDeadline)).format(
          this.$t('automateReminder.dateFomatForUI')
        ); //format date to dd.mm.yyyy and return
      } catch (error) {
        console.error(error);
        return '';
      }
    },

    /** get formated date from polls choice for rediobutton ->  before next date option*/
    beforeNextDateForReminder() {
      try {
        if (this.poll && this.poll.type && this.poll.type != 1)
          return this.$t('automateReminder.availableInDatePollOnly');
        if (this.pollDeadline) return this.$t('automateReminder.notAvailable'); // date not found than reurn default message (not available)
        let _days;
        if (this.poll.delay_interval) {
          _days = this.poll.delay_interval;
          _days = _days.sort((a, b) => b - a);
        }
        /** if poll date found than return first date by substract days */
        if (this.poll && this.poll.choices && this.poll.choices.length > 0) {
          let todayDate = moment(new Date()).format(
            this.$t('automateReminder.dateFomatForUI')
          );
          for (let i = 0; i < this.poll.choices.length; i++) {
            if (this.poll.choices[i].start) {
              for (
                let deadlineIndex = 0;
                deadlineIndex < _days.length;
                deadlineIndex++
              ) {
                let date = moment(String(this.poll.choices[i].start))
                  .subtract(_days[deadlineIndex], 'days')
                  .format(this.$t('automateReminder.dateFomatForUI')); //substtract by largest days and format
                if (date >= todayDate) {
                  return moment(this.poll.choices[i].start).format(
                    this.$t('automateReminder.dateFomatForUI')
                  );
                }
              }
            }
          }
        }
        return this.$t('automateReminder.notAvailable');
      } catch (error) {
        console.error(error);
        return this.$t('automateReminder.notAvailable');
      }
    },

    /* enable or disable automatedReminder days ->  check boxs*/
    isDisableChoices() {
      try {
        if (!this.isPremium || !this.pollDeadline) return true;

        // let choice = null;
        // if(this.poll && this.poll.choices && this.poll.choices.length > 0){
        //   choice = this.poll.choices
        // }
        // if(!this.pollDeadline && !choice || choice == null)  return true;

        return false;
      } catch (error) {
        console.error(error);
        return false;
      }
    },

    /** disable  -> redio button -> before dealine */
    isDisableBeforeDealine() {
      if (!this.isPremium) return true;

      let choice = null;
      if (this.poll && this.poll.choices && this.poll.choices.length > 0) {
        choice = this.poll.choices;
      }

      if (!this.pollDeadline && (!choice || choice == null)) return true;

      if (choice && choice.length > 0 && !this.pollDeadline) return true;

      return false;
    },
    /* disable -> radio btton -> before next date option */
    isDisableBeforeNextDateOption() {
      if (
        !this.isPremium ||
        (this.poll && this.poll.type && this.poll.type != 1)
      )
        return true;

      let choice = null;
      if (this.poll && this.poll.choices && this.poll.choices.length > 0) {
        choice = this.poll.choices;
      }

      if (
        (!this.pollDeadline && (!choice || choice == null)) ||
        (choice && choice.length > 0 && this.pollDeadline)
      ) {
        return true;
      }

      return false;
    },

    mayBeAnswerDisabled() {
      if (this.poll.options.limitedVotesPerChoice) return true;
      if (this.poll.options.oneChoicePerParticipant) return true;
      return false;
    },

    isEvent() {
      if (this.type == 2) return true;
      return false;
    },

    adminUrl() {
      let adminKey =
        this.ownerId.substring(this.ownerId.length - 4) + this.ownerId;
      let url =
        process.env.VUE_APP_FRONTEND_URI +
        '/pr/' +
        this.poll.id +
        '/' +
        adminKey;
      return url;
    },

    invitations() {
      return this.poll.invitations;
    },

    invitationUrl() {
      let url = process.env.VUE_APP_FRONTEND_URI + '/pr/' + this.poll.id + '/';
      return url;
    },

    title: {
      get() {
        return this.poll.title;
      },
      set(value) {
        this.$store.commit('updateTitle', value);
        this.validateForm();
      },
    },

    type: {
      get() {
        return this.poll.type;
      },
      set(value) {
        //this.isTypeSelected = true;
        console.info('set type:', value);
        switch (this.poll.type) {
          case 1:
            this.dateChoices = copy(this.poll.choices);
            break;

          case 2:
            break;

          case 3:
            this.textChoices = copy(this.poll.choices);
            break;
        }
        switch (value) {
          case 1:
            this.poll.choices = this.dateChoices;
            break;

          case 2:
            break;

          case 3:
            this.poll.choices = this.textChoices;
            break;
        }

        this.$store.commit('updateType', value);
      },
    },

    description: {
      get() {
        return this.poll.description;
      },
      set(value) {
        this.$store.commit('updateDescription', value);
      },
    },

    name: {
      get() {
        console.log('name-->', this.ownerUser, this.user);
        if (this.ownerUser == null) {
          if (this.user) return this.user.name;
        }
        return this.ownerUser.name;
      },
      set(value) {
        this.ownerUser.name = value;
        this.$store.commit('updateName', value);
      },
    },

    email: {
      get() {
        if (this.ownerUser == null) {
          if (this.user) return this.user.email;
        } else if(!this.isAuthenticated && this.ownerUser.email == null) {
          console.log("user is not logged in so getting details from participant");
          for(let i = 0; i < this.poll.participants.length; i++) {
            if(this.$route.params.key == this.poll.participants[i].invitation_id) {
              return this.poll.participants[i].user.email;
            }
          }
        }
        return this.ownerUser.email;
      },
      set(value) {
        this.ownerUser.email = value;
        this.$store.commit('updateEmail', value);
      },
    },

    mayBeAnswers: {
      get() {
        return this.poll.options.mayBeAnswers;
      },
      set(value) {
        this.$store.commit('updateMayBeAnswers', value);
      },
    },

    limitedVotesPerChoice: {
      get() {
        return this.poll.options.limitedVotesPerChoice;
      },
      set(value) {
        if (value) {
          this.poll.options.mayBeAnswers = false;
        }
        this.$store.commit('updateLimitedVotesPerChoice', value);
      },
    },

    votesLimit: {
      get() {
        return this.poll.options.votesLimit;
      },
      set(value) {
        console.log('updateVotesLimit');
        this.$store.commit('updateVotesLimit', value);
      },
    },

    darkMode: {
      get() {
        if (this.poll.options.darkMode == null) return false;
        return this.poll.options.darkMode;
      },
      set(value) {
        if (this.designs.length == 0) {
          this.loadDesign().then(() => {
            this.$store.commit('updateDarkMode', value);
            this.updateDesignTemplate(value);
          });
        } else {
          this.$store.commit('updateDarkMode', value);
          this.updateDesignTemplate(value);
        }
      },
    },

    oneChoicePerParticipant: {
      get() {
        return this.poll.options.oneChoicePerParticipant;
      },
      set(value) {
        if (value) {
          this.poll.options.mayBeAnswers = false;
        }
        this.$store.commit('updateOneChoicePerParticipant', value);
      },
    },

    showStatisticToParticipants: {
      get() {
        return this.poll.options.showStatisticToParticipants;
      },
      set(value) {
        this.$store.commit('updateShowStatisticToParticipants', value);
      },
    },

    allowComments: {
      get() {
        return this.poll.options.allowComments;
      },
      set(value) {
        this.$store.commit('updateAllowComments', value);
      },
    },

    allowTasks: {
      get() {
        return this.poll.options.allowTasks;
      },
      set(value) {
        this.$store.commit('updateAllowTasks', value);
      },
    },

    hiddenPoll: {
      get() {
        return this.poll.options.hiddenPoll;
      },
      set(value) {
        this.$store.commit('updateHiddenPoll', value);
      },
    },

    notifyOnNewAnswer: {
      get() {
        return this.poll.options.notifyOnNewAnswer;
      },
      set(value) {
        this.$store.commit('updateNotifyOnNewAnswer', value);
      },
    },

    notifyOnNewUser: {
      get() {
        return this.poll.options.notifyOnNewUser;
      },
      set(value) {
        this.$store.commit('updateNotifyOnNewUser', value);
      },
    },

    showCounts: {
      get() {
        return this.poll.options.showCounts;
      },
      set(value) {
        this.$store.commit('updateShowCounts', value);
      },
    },

    delayInterval: {
      get() {
        return this.poll.delay_interval || [];
      },
      set(value) {
        this.$store.commit('updateDelayInterval', value);
      },
    },

    delayType: {
      get() {
        if (this.poll.delay_type) {
          return this.poll.delay_type;
        }
        return null;
      },
      set(value) {
        this.$store.commit('updateDelayType', value);
      },
    },

    isNewPoll() {
      return this.poll.options.initialised == false;
    },

    isAnonymousUser() {
      if (this.poll.user.email == 'dummy@kulibri.com') {
        return true;
      }
      return false;
    },

    header() {
      if (this.isNewPoll) {
        return this.$t('create.dlgHeaderNew');
      }
      return this.$t('create.dlgHeaderEdit');
    },

    saveText() {
      return this.$t('create.dlgSaveDone');
    },

    cancelText() {
      return this.$t('create.dlgCancel');
    },

    getCustomClass() {
      return this.displayScroll
        ? 'descriptionTextarea descriptionTextareaScroll'
        : 'descriptionTextarea';
    },

    getDescriptionLength() {
      return (
        (this.description ? this.description.length : 0) +
        ' / ' +
        constants.textAreaMaxCharacterLimit
      );
    },
  },

  watch: {
    pollDeadline: {
      deep: true,
      handler: function () {
        if (this.pollDeadline == null) {
          // when unhide the choice deadline, please remove this one
          this.delayType = null;
          this.delayInterval = null;
        } else if (this.pollDeadline && this.delayType == 'before_next_date') {
          this.delayType = null;
        }
        console.log('date was updated', this.pollDeadline);
        //this.showDeadlinePicker = false;
        this.$store.commit('updateDeadline', this.pollDeadline);
      },
    },
    delayInterval: {
      deep: true,
      handler: function () {
        this.delayType =
          this.pollDeadline && this.delayInterval.length > 0
            ? 'before_deadline'
            : null;
      },
    },
    ownerUser: {
      handler() {
        this.validateForm();
      },
      deep: true,
    },
    description: {
      handler() {
        this.calculateDescriptionHeight();
      },
    },
  },

  methods: {
    ...mapActions([
      'updateSelectedTemplate',
      'updateDesignIdInPoll',
      'loadDesign',
    ]),


    setTypeSeletcted() {
      console.info("Set type selected");
      this.setTypeSeletcted = true;
    },

    /* methods for answer configuration */
    openConfigureAnswer() {
      this.$emit('openConfigureAnswer');
    },

    /* methods for edit dates */
    onDayClick(day) {
      console.log('onDayClick:', day);
    },

    /* methods for appearance setup */
    selectBGImage() {
      console.info('EditPoll - selectBGImage');
      this.$emit('change');
    },

    openCustomBranding() {
      this.$emit('openCustomBranding');
    },

    onRemoveOK() {
      this.showConfirm = false;
      this.$emit('remove');
    },

    onRemoveCancel() {
      this.showConfirm = false;
    },

    onCancel() {
      if (this.isNewPoll) {
        this.showConfirm = true;
        return;
      }
      this.$store.commit('updateDescription', this.backup.description);
      this.$store.commit('updateTitle', this.backup.title);
      this.$store.commit('updateDeadline', this.backupDeadline);
      this.$store.commit('updateChoices', this.backupChoices);
      this.poll.options = this.backup.options;

      // let details = {
      //   title: this.poll.title,
      //   type: this.poll.type,
      //   description: this.poll.description,
      //   options: this.poll.options,
      //   ownerUser: this.ownerUser,
      //   bg_image_path: this.backgroundThumbnail,
      //   closed: this.poll.closed,
      //   deadline: this.poll.deadline,
      //   design_id: this.poll.design_id,
      //   delay_interval: this.poll.delay_interval,
      //   delay_type: this.poll.delay_type,
      // };
      //this.$store.dispatch('updateDetails', details).then(() => {});

      this.$emit('cancel');
    },

    onSave() {

      if( this.poll.type < 1 ) {
        return;
      }

      if (
        !this.isValidEmailField() ||
        !this.isValidUserName(this.$t('general.userName'))
      )
        return;
      if(this.poll.type == 1 && this.poll.choices.length == 0) {
        // date poll
        this.$refs.dlgZeroChoiceValidation.openModal();
        return;
      } else if(this.poll.type == 3) {
        // text poll
        if(this.poll.choices.length == 0) {
          this.$refs.dlgZeroChoiceValidation.openModal();
          return;
        } else {
          let foundValid = false;
          for(let i = 0; i < this.poll.choices.length; i++) {
            if(this.poll.choices[i].text != null && this.poll.choices[i].text.trim().length > 0) {
              foundValid = true;
              break;
            }
          }
          // if did not found any fillable text in option we can display the popup
          if(foundValid == false) {
            this.$refs.dlgZeroChoiceValidation.openModal();
            return;
          }
        }
      }
      if (this.ownerUser && this.ownerUser.email) {
        this.ownerUser.locale = this.$i18n.locale;
      }
      console.log('editingKulibri done - ownerUser:', this.ownerUser);
      console.log('getSelectedTemplate ==> ', this.getSelectedTemplate);

      let details = {
        title: this.poll.title,
        type: this.poll.type,
        description: this.poll.description,
        options: this.poll.options,
        ownerUser: this.ownerUser,
        bg_image_path: this.backgroundThumbnail,
        closed: this.poll.closed,
        deadline: this.poll.deadline,
        design_id: this.getSelectedTemplate.id,
        delay_interval: this.poll.delay_interval,
        delay_type: this.poll.delay_type,
      };

      // remove the ownerUser if you are editing an exiting poll
      // changed by Mitko to avoid updating participants (an issue if the owner is not participant)
      if (!this.isNewPoll) {
        details.ownerUser = null;
      }
      console.log('editingKulibri on save details:', details);

      const userId = this.poll.user.id;
      const newUserName = this.ownerUser.name;
      const key = this.poll.key;
      this.loading = true;
      this.$store.dispatch('updateChoices', this.poll.choices).then(() => {
        this.$store.dispatch('updateDetails', details).then((response) => {
          const poll = response.data;
          this.updateSelectedTemplate(response.data.design);
          this.updateDesignIdInPoll(response.data.design_id);

          // These two condition is mainly used for participantBackup
          if (this.isNewPoll) {
            this.$store.dispatch('updateAdminUserNameWhenCreateNewPoll', newUserName);
            this.$store.dispatch('updateAdminBackUpPreferenceList', poll.participants[0].preference_list || []);
          }

          poll.options.initialised = true;
          this.poll.options.initialised = true;
          this.$store.commit('updateOptions', poll.options);

          if(userId == poll.user.id) {
            // when create poll, participantBackup was created with empty preference_list so when update the poll, need to update the preference list as well.
            for(let i = 0; i < poll.participants.length; i++) {
              if(poll.participants[i].user_id == userId) {
                this.$store.dispatch('updateAdminBackUpPreferenceList', poll.participants[i].preference_list || []);
                break;
              }
            }
          }

          if (this.isNewPoll) {
            console.log('updateDetails completed:', userId, poll.user.id);
            poll.key = key; // use the old key because it is obfuscated
            // check if new user was assigned during "create new poll"
            if (userId !== poll.user.id) {
              let participant = poll.participants[0];
              participant.isCurrentUser = true;
              this.$store.commit('setPoll', poll);
              console.log('new user was asigned:', this.poll.participants);
            }
            this.$store.commit('updateName', newUserName);
          }
          this.loading = false;
          this.$emit('save');
        });
      });
    },

    whenSelect() {
      // const name = this.poll.user.name;
      // const email = this.poll.user.email;
      console.info('whenSelect:', this.poll.choices);
      this.$store.commit('updateChoicesNoSort', this.poll.choices);
    },
    validateForm() {
      if (
        this.title.trim().length == 0 ||
        (this.isNewPoll == true && this.name.trim().length == 0) ||
        (this.isNewPoll == true && this.email.trim().length == 0)
      ) {
        this.disable = true;
      } else {
        this.disable = false;
      }
    },
    calculateDescriptionHeight() {
      let descriptionTextAreaControl = document.getElementsByClassName(
        'descriptionTextarea'
      );
      if (descriptionTextAreaControl && descriptionTextAreaControl.length > 0) {
        let height = 0;
        if (descriptionTextAreaControl[0].value.length > 0) {
          height = descriptionTextAreaControl[0].offsetHeight || 0;
        }
        if (height == 0 || height == 25) {
          height =
            descriptionTextAreaControl[0].value.split('\n').length < 10
              ? 0
              : constants.textAreaMaxHeight;
        }
        this.displayScroll = height >= constants.textAreaMaxHeight;
      }
    },
    redirectToPage() {
      if (this.dialogContent.type == 'register') {
        // check if the current url a project link is and if clear admin and public keys
        let redirectUrl = this.$route.path;
        if (redirectUrl) {
          const pathArray = redirectUrl.split('/');
          redirectUrl = '/pr/' + pathArray[2];
        }

        this.$router.push({
          path: '/signin?url=' + redirectUrl,
          redirect: redirectUrl,
          props: true,
        });
      } else {
        this.$router.push('/membership');
      }
    },
    updateDesignTemplate(modeValue) {
      let darkModeString = modeValue == true ? 'dark' : 'light';
      // this.updateSelectedTemplate(response.data.design);
      for (let i = 0; i < this.designs.length; i++) {
        if (
          this.designs[i]['isDefault'] == true &&
          this.designs[i]['name'].includes(darkModeString)
        ) {
          this.updateSelectedTemplate(this.designs[i]);
          if (darkModeString == 'dark') {
            customTemplate.updateDarkModeOpacity(
              this.designs[i].config.answerGridSection.darkModeOpacity / 100
            );
          } else {
            customTemplate.updateLighModeOpacity(
              this.designs[i].config.answerGridSection.darkModeOpacity / 100
            );
          }
          // customTemplate.renderHTML(this.designs[i]);
          break;
        }
        // if(this.designs[i]['id'] == this.poll.design_id) {
        //   this.$refs.refBrandingTemplate.updateTemplate(this.designs[i]);
        //   this.$refs.refBrandingTemplate.renderValue();
        //   break;
        // }
      }
    },
    closeValidationModal() {
      this.$refs.dlgZeroChoiceValidation.closeModal();
    }
  },

  created() {
    // this.backup.title = this.poll.title;
    // this.backup.description = this.poll.description;
    this.backup.options = JSON.parse(JSON.stringify(this.poll.options));
    if (this.isAnonymousUser) {
      let ownerName = ''; //this.$t('general.userName');
      this.ownerUser = { name: '', email: '' };
      this.$store.commit('updateName', ownerName);
      this.$store.commit('updateEmail', '');
    } else {
      let tempCreatorId = this.poll.user_id;
      var pos = this.poll.participants.findIndex((obj) => {
        if (obj.user) return obj.user.id == tempCreatorId;
        return false;
      });

      // this is needed becuase usr and participants are not synced after "reassignToUser" in the backend
      if (pos === -1) {
        const email = this.poll.user.email;
        this.ownerUser = { name: this.poll.user.name, email: email };
      } else {
        this.ownerUser = {
          name: this.poll.participants[pos]['name'],
          email: this.poll.participants[pos]['user']['email'],
        };
      }
    }
    console.log('new user created:', this.ownerUser);
  },
  mounted() {
    console.info("EditPoll - mounting");
    // if( !this.isNewPoll) this.isTypeSelected = true;
    this.calculateDescriptionHeight();
    this.backupDeadline = this.poll.deadline;
    this.backupDeadline = this.poll.deadline;
    this.backupChoices = JSON.parse(JSON.stringify(this.poll.choices));
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style';
// input.form-control:focus {
//   box-shadow: 0 0px 0px rgba(0, 0, 0, 0.075) inset,
//     0 0 0px rgba(126, 239, 104, 0.6);
//   outline: 0 none;
// }

.a-self {
  align-self: center;
}

.deadline > .btn-sm {
  padding-left: 4px;
  padding-right: 4px;
}

.panel-section-header {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 8px 32px;
  margin-bottom: 8px;
  margin-top: 0px;
  line-height: 20px;
  margin-left: -16px;
  margin-right: -16px;
}

.mr-10 {
  margin-right: 10px !important;
}
.disabled-text {
  color: gray !important;
}
.backgroundButton {
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.toggle-description {
  color: $mid-grey;
}

.custom-logo-image {
  width: 40px;
  height: 40px;
  background: #1d1d1d;
  object-fit: contain;
}

.logo-manager-parent {
  cursor: pointer;
  justify-content: space-between;
  .logo-image-update {
    display: block;
  }
  // label, button {
  //   word-break: break-word;
  //   white-space: normal;
  //   width: 100px;
  //   color: $primary;
  // }
}

.reminder-in-days {
  justify-content: space-between;
}

::v-deep .limited-votes {
  .k-input-group {
    align-items: end;

    textarea {
      text-align: center;
      margin-right: 5px;
      border: 1px solid $dark-grey;
      width: 50px;
      white-space: nowrap;
      background: white;
    }
  }
}

::v-deep .descriptionTextareaScroll {
  overflow: auto !important;
}

::v-deep .vc-time-picker {
  justify-content: center !important;
}
</style>
